export const shouldRedirectAuthenticatedUserFromAuthPage = ({
  isAuthenticated,
  typeformEmail,
}) => Boolean(isAuthenticated && typeformEmail == null);

export const shouldShowAuthFormAfterTypeformReturn = ({
  isTestCompleted,
  isTypeformLookupSettled,
  testLookupFailed,
  typeformEmail,
}) =>
  Boolean(
    !typeformEmail ||
      (isTypeformLookupSettled && (testLookupFailed || isTestCompleted))
  );
